import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SmartLabelPref} from '../constants';

export const smartLabelsVideoEnabled = () =>
	getPreference(SmartLabelPref.VIDEO_ENABLED, true);
